import { render, staticRenderFns } from "./WebPartCardSetting.vue?vue&type=template&id=618b0c8a&"
import script from "./WebPartCardSetting.vue?vue&type=script&lang=js&"
export * from "./WebPartCardSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports